import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ScarecrowImage from '../../../../../../assets/images/scarecrow.png';

export default function NoRosterContent() {
  return (
    <Stack spacing={2} direction="column" className="audience-editor-no-roster">
      <img className="audience-editor-no-roster-image" alt="" src={ScarecrowImage} />
      <Typography variant="body1">
        You do not belong to any school!
      </Typography>
    </Stack>
  );
}
